module.exports = __webpack_public_path__ + "static/media/header-search-icon.de1c90d5.svg";